import { useQuery } from '@tanstack/react-query'
import { fetchQueuedActions, partyActionKeys } from '@/services/partyActions'
import type { PartyAction } from '@/types'

/**
 * Hook to get queued actions for a party for the current tick.
 *
 * Returns all actions with status 'queued' for the specified party and tick.
 *
 * @param partyId - The party to check (optional, hook is disabled if undefined)
 * @param currentTick - The current game tick (optional, hook is disabled if undefined)
 * @returns Object with queued actions array, plus loading/error states
 */
export function useQueuedActions(
  partyId: string | undefined,
  currentTick: number | undefined
) {
  const query = useQuery({
    queryKey: partyActionKeys.queued(partyId!, currentTick!),
    queryFn: () => fetchQueuedActions(partyId!, currentTick!),
    enabled: !!partyId && currentTick !== undefined,
  })

  return {
    actions: (query.data ?? []) as PartyAction[],
    isLoading: query.isLoading,
    error: query.error,
  }
}
